<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00035"><a class="calibre23" id="CHAPTER_IV"></a>CHAPTER IV.</h2>
<p class="center1"><strong class="calibre4">STARTING INTO THE WORLD.</strong></p>
<p class="calibre3">As Rod finished speaking he left the room and walked away. He had hardly
disappeared, and the fellows were still looking at each other in a
bewildered fashion, when a message was sent in. It was that President
Vanderveer, who was distributing the prizes for the several races out in
front of the grand stand, was ready to present the Railroad Cup to Rodman
Blake, and wanted him to come and receive it. Then somebody went out and
whispered to the President. Excusing himself for a moment to the throng of
spectators, he visited the dressing-room, where he heard the whole story.
It was hurriedly told; but he comprehended enough of it to know that the
cup could not, at that moment, be presented to anybody. So he went back,
and with a very sober face, told the people that owing to circumstances
which he was not at liberty to explain just then, it was<span id="pgepubid00036" title="[Pg 23]"></span> impossible to
award the Railroad Cup at that meeting.</p>
<p class="calibre3">The crowd slowly melted away; but before they left, everybody had heard
one version or another of the story told to President Vanderveer in the
dressing-room. Some believed Rod to be innocent of the charge brought
against him, and some believed him guilty. Almost all of them said it was
a pity that such races could not be won and lost honestly, and there must
be some fire where there was so much smoke; and they told each other how
they had noticed from the very first that something was wrong with Snyder
Appleby’s wheel.</p>
<p class="calibre3">Major Appleby heard the story, first from President Vanderveer, and
afterwards from his adopted son, who confirmed it by displaying the side
of his face which was swollen and bruised from Rodman’s blow. Fully
believing what Snyder told him, the Major became very angry. He declared
that no such disgrace had ever before been brought to his house, and that
the boy who was the cause of it could no longer be sheltered by his roof.
In vain did people talk to him, and urge him to reflect before he acted.
He had decided upon his course, and the more they<span id="pgepubid00037" title="[Pg 24]"></span> advised him, the more
determined he became not to be moved from it.</p>
<p class="calibre3">While he was thus storming and fuming outside the dressing-room, the
members of the wheel club were holding a meeting behind its closed door.
Did they believe Rodman Blake guilty of the act charged against him or did
they not? The debate was a long and exciting one; but the question was
finally decided in his favor. They did not believe him capable of doing
anything so mean. They would make a thorough investigation of the affair,
and aid him by every means in their power to prove his innocence.</p>
<p class="calibre3">This was the purport of the message sent to the young captain by the club
secretary, Billy Bliss; but it was sent too late. The members had taken no
note of time in the heat of their discussion, and the hour named by Rodman
had already elapsed before Billy Bliss started on his errand. The fellows
did not think a few minutes more or less would make any difference, though
they urged the secretary to hurry and deliver his message as quickly as
possible. A few minutes however did make all the difference in the world
to Rod Blake. With him an hour meant<span id="pgepubid00038" title="[Pg 25]"></span>
exactly sixty minutes; and when
Billy Bliss reached Major Appleby’s house the boy whom he sought was
nowhere to be found.</p>
<p class="calibre3">Major Appleby and his adopted son walked home together, the former full of
wrath at what he believed to be the disgraceful action of his nephew, and
the latter secretly rejoicing at it. On reaching the house, the Major went
at once to Rodman’s room where he found the boy gazing from the window,
with a hard, defiant, expression on his face. He was longing for a single
loving word; for a mother’s sympathetic ear into which he might pour his
griefs; but his pride was prepared to withstand any harshness, as well as
to resent the faintest suspicion of injustice.</p>
<p class="calibre3">“Well, sir,” began the Major, “what have you to say for yourself? and how
do you explain this disgraceful affair?”</p>
<p class="calibre3">“I cannot explain it, Uncle; but——”</p>
<p class="calibre3">“That will do, sir. If you cannot explain it, I want to hear nothing
further. What I do want, however, is that you shall so arrange your future
plans that you may no longer be dependent on my roof for shelter. Here is
sufficient money for your<span id="pgepubid00039" title="[Pg 26]"></span>
immediate needs. As my sister’s child you have
a certain claim on me. This I shall be willing to honor to the extent of
providing you against want, whenever you have settled upon your mode of
life, and choose to favor me with your future address. The sooner you can
decide upon your course of action the better.” Thus saying the
kind-hearted, impetuous, and wrong-headed old Major laid a roll of bills
on the table, and left the room.</p>
<p class="calibre3">Fifteen minutes later, or five minutes before Billy Bliss reached the
house, Rod Blake also left the room. The roll of bills lay untouched where
his uncle had placed it, and he carried only his M. I. P. or bicycle
travelling bag, containing the pictures of his parents, a change of
underclothing, and a few trifles that were absolutely his own. He passed
out of the house by a side door, and was seen but by one person as he
plunged into the twilight shadows of the park. Thus, through the gathering
darkness, the poor boy, proud, high-spirited, and, as he thought,
friendless, set forth alone, to fight his battle with the world.</p>
<p class="calibre3"><span id="pgepubid00040" title="[Pg 27]"></span></p>
<div class="pg-boilerplate" id="calibre_pb_18"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?1451de9a